import { useContext } from "react";
import {
  CatalogContext,
  IProductsCatalog,
} from "src/api/context/CatalogContext";
import { Flex, Text, Box, Badge } from "@mantine/core";

function ProductSelection({ product }: { product: IProductsCatalog[0] }) {
  const { productsCart, handleProductSelection, selectedProduct } =
    useContext(CatalogContext);

  let isProductSelectable =
    !!productsCart.find((p) => p.id === product.id) || !product.stock;

  return (
    <>
      <Flex
        key={product.id}
        direction={"column"}
        align={"center"}
        justify={"center"}
        sx={(theme) => ({
          height: 96,
          width: 76,
          borderRadius: 4,
          cursor: "pointer",
          position: "relative",
          backgroundColor: theme.colors.secondary[1],
          ":hover": {
            background: theme.colors.secondary[6],
            color: theme.colors.secondaryTextColor[6],
          },
          ...(product.id === selectedProduct?.id && {
            background: theme.colors.primary[6],
            color: theme.colors.primaryTextColor[6],
          }),
          ...(isProductSelectable && {
            background: theme.colors.secondary[1],
            color: theme.colors.secondaryTextColor[1],
            pointerEvents: "none",
          }),
        })}
        onClick={() => !isProductSelectable && handleProductSelection(product)}
      >
        {!product.stock && (
          <Badge
            color="red"
            size={"xs"}
            radius={"md"}
            sx={{ position: "absolute", transform: "rotate(320deg)", top: 30 }}
          >
            Out of stock
          </Badge>
        )}
        <Box
          sx={(theme) => ({
            height: 70,
            width: 70,
            background: theme.colors.gray[1],
            borderRadius: 4,
          })}
        >
          {product.imgUrl && (
            <img
              src={product.imgUrl || ""}
              style={{ height: "100%", width: "100%", objectFit: "cover" }}
              alt="Product Image"
            />
          )}
        </Box>
        <Text
          sx={{
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            width: "inherit",
            textAlign: "center",
            lineHeight: 1,
            padding: "2px 4px",
          }}
        >
          {product.name}
        </Text>
      </Flex>
    </>
  );
}
export default ProductSelection;
